import React, { useEffect, useState } from "react";
import "./css/tablestudycost.css";

const allStudyCostContent = [
  {
    countryName: "GERMANY",
    countryShort: "Germany",
    overview:
      "An International Degree Course is a type of course that covers undergraduate",
      studylivingcost:  "10,200-15,000/- Euros  Per Annum",
    studyPrograms: [
      {
        studyProgramName: "Bachelor’s Degree ",
        studyProgramCost: "7000/- Euros Per Annum",
        
      },
      {
        studyProgramName: "Master’s Degree",
        studyProgramCost: "9000/- Euros  Per Annum",
        
      },
    ],
  },
  {
    countryName: "U.S.A.",
    countryShort: "U.S.A.",
    overview: "",
    studylivingcost:  "$10000 to $18000/- Per Annum",
    studyPrograms: [
      {
        studyProgramName: "Undergraduate Program",
        studyProgramCost: "$15,000 to $35,000/- Per Annum",
       
      },
      {
        studyProgramName: "Postgraduate master's Program ",
        studyProgramCost: "$15,000 to $35,000/- Per Annum",
        
      },
     
    ],
  },
  {
    countryName: "UNITED KINGDOM",
    countryShort: "UK",
    overview:
      "Types of Scholarships available for international students in the United Kingdom",
      studylivingcost:  "£ 7,620 TO £ 16,320/- Per Annum",
    studyPrograms: [
      {
        studyProgramName: "Bachelor’s Degree ",
        studyProgramCost: "£ 16,000 to £ 38,000/- Per Annum ",
       
      },
      {
        studyProgramName: "Master’s Degree ",
        studyProgramCost: "£ 11,000 to  £ 32,000/- Per Annum ",
       
      },
      
    ],
  },
  {
    countryName: "CANADA",
    countryShort: "Canada",
    overview:
      "There are three types of scholarships available for study abroad Canada",
      studylivingcost:  "CAD 15,000 CAD - 20,000/- Per Annum",
    studyPrograms: [
      {
        studyProgramName: "Undergraduate Program",
        studyProgramCost: "CAD 14,000 to 35,000/- Per Annum ",
      
      },
      {
        studyProgramName: "Postgraduate master's Program ",
        studyProgramCost: "CAD 10,000 to 35,000/- Per Annum",
       
      },
     
    ],
  },
  {
    countryName: "U.A.E",
    countryShort: "U.A.E",
    overview:
      "In Dubai, you can study on fully or partially funded scholarships. Every year, the government of Dubai and universities in Dubai award scholarships to international students and local residents, here is a compiled list of some of the best PhD Scholarships in Dubai, Masters Scholarships in Dubai, and undergraduate level scholarships.",
    studylivingcost:  "AED 30000 TO 55000/- Per Annum",
    studyPrograms: [
      {
        studyProgramName: "Under Graduates ",
        studyProgramCost: "AED 40,000 to 50,000/- Per Annum",
       
      },
      {
        studyProgramName: "Post Graduate",
        studyProgramCost: "AED 52,800  to 84,000/- Per Annum",
       
      },
    ],
  },
  {
    countryName: "AUSTRALIA",
    countryShort: "Australia",
    overview:
      "There is a vast variety of scholarships available for international students.",
    studylivingcost:  "AUD 16000- AUD 30000",
    studyPrograms: [
     
      {
        studyProgramName: "Undergraduate Program",
        studyProgramCost: "AUD 18,000 - 35,000 Per Annum",
       
      },
      {
        studyProgramName: "Postgraduate master's Program ",
        studyProgramCost: "AUD 20,000 -  42,000 Per Annum",
       
      },

      
    ],
  },
];

function StudyCostTable(props) {
  const [expansionOpen, setExpansionOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(1);
  const [selectedCountryInfo, setSelectedCountryInfo] = useState({
    countryName: "GERMANY",
    countryShort: "Germany",
    overview:
      "An International Degree Course is a type of course that covers undergraduate",
    studyPrograms: [
      {
        studyProgramName: "Bachelor’s Degree ",
        studyProgramCost: "£16,000 to £38,000 Per Annum ",
      },
      {
        studyProgramName: "Master’s Degree ",
        studyProgramCost: "£ 11,000 to  £ 32,000 Per Annum ",
      },
      
    ],
  });
  useEffect(() => {
    if (props.selectedTab) {
      const countryInfo = allStudyCostContent.findIndex((info) => {
        return info.countryName === props.selectedTab;
      });

      setSelectedCountryInfo(allStudyCostContent[countryInfo]);
    }
  }, [props.selectedTab]);

  return (
    <section className="sectin_main_container_study_cost">
      <div className="sectin_under_main_container_study_cost">
        <div className="table_title_content_contianer">
          <div
            className="text_title_study_cst text-center wow bounceIn"
            data-wow-delay="0.5s"
            data-wow-duration="2s"
          >
            <p
              className="wow bounceIn"
              data-wow-delay="0.5s"
              data-wow-duration="2s"
            >
              STUDY COST IN THE {selectedCountryInfo.countryName}
            </p>
          </div>
          <table className="table_self">
            <tbody>
              <tr className="heading_tble">
                <th>Study Program</th>
                <th>Average Tution fees</th>
                
              </tr>
              {selectedCountryInfo.studyPrograms.map((perStudyData) => {
                return (
                  <tr key={Math.random()}>
                    <td>{perStudyData.studyProgramName}</td>
                    <td>{perStudyData.studyProgramCost}</td>
                    
                  </tr>
                  
                );
              })}
              
            </tbody>
          </table>
          <p
              className="text_title_study_cst text-center cost"
            >
             AVERAGE STUDY COST IN THE {selectedCountryInfo.countryName} IS {selectedCountryInfo.studylivingcost}
            </p>
        </div>
        
      </div>
      
    </section>
  );
}

export default StudyCostTable;
